exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InstagramBusinessChannelStatistics h3 {\n  font-size: 1rem;\n  font-weight: 500;\n  font-style: normal;\n}\n", ""]);

// exports
